import React, { useState } from 'react';
import { connect } from 'react-redux';

import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';

import Button from '../shared/Button';
import Alert from '../shared/Alert';
import Modal from './Modal';

import { withFirebase } from '../../firebase';

import '../dashboard/dashboard.scss';

const Disable2FAModal = (props) => {
  const {
    open,
    onClose,
    firebase,
    phone,
    onSuccess,
  } = props;

  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async () => {
    setLoading(true);
    try {
      if (!!password) {
        // const formatted = !phone?.includes('+') ? `+${phone}` : phone;
        await firebase.disable2FA(password);
        onSuccess();
        onClose();
      }
    } catch (err) {
      setError('Something went wrong. Please contact administrator.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        onClose();
        setPassword('');
      }}
      onSubmit={onSubmit}
      title="Disable 2FA"
    >
      <div className="p-lg">
        <div className='secondary m-b-md'>To disable 2FA authentication you have to re-enter your current password for security purposes.</div>
        <Grid container spacing={0}>
          <Grid size={{ xs: 12, sm: 12 }}>
            <div className="p-t-md">
              <TextField
                id="password"
                type="password"
                label="Current password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                fullWidth
              />
            </div>
          </Grid>
        </Grid>
        <div className="actions m-t-lg d-flex flex-end">
          <Button
            text="Submit"
            color="primary"
            onClick={onSubmit}
            disabled={loading}
            loading={loading}
          />
        </div>
      </div>

      <Alert variant="error" message={error} open={!!error} onClose={() => setError(null)} />
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    phone: state.user.currentUser.phone,
  };
};

export default connect(mapStateToProps)(withFirebase(Disable2FAModal));
